import { render } from "./MyPermissions.vue?vue&type=template&id=6ec80a7e&scoped=true"
import script from "./MyPermissions.vue?vue&type=script&lang=js"
export * from "./MyPermissions.vue?vue&type=script&lang=js"

import "./MyPermissions.vue?vue&type=style&index=0&id=6ec80a7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec80a7e"]])

export default __exports__